<form>
	<div class="row margin-bottom-sm">
		<div class="col-lg-6 col-xl-4">
			<div class="row mb-3 margin-bottom-0" [attr.data-test-id]="'readOnlyApplyFullFormGroup'">
				<label class="col-md-4 col-form-label">Payment Amount</label>
				<div class="col-md-8">
					@if (paymentGroup.applyFull) {
						<p class="form-control-static">{{ paymentGroup.paymentAmount | currency }} (Apply in Full selected)</p>
					}
					@if (!paymentGroup.applyFull) {
						<p class="form-control-static">{{ paymentGroup.paymentAmount | currency }}</p>
					}
				</div>
			</div>
			<div class="row mb-3 margin-bottom-0" [attr.data-test-id]="'readOnlyCreditCardFormGroup'">
				<label class="col-md-4 col-form-label">Payment Method</label>
				<div class="col-md-8">
					@if (paymentGroup.creditCardType) {
						<p class="form-control-static">{{ paymentGroup.paymentMethodType }} - {{ paymentGroup.creditCardType }}</p>
					}
					@if (!paymentGroup.creditCardType) {
						<p class="form-control-static">{{ paymentGroup.paymentMethodType }}</p>
					}
				</div>
			</div>
		</div>
		<div class="col-lg-6 col-xl-4">
			<div class="row mb-3 margin-bottom-0" [attr.data-test-id]="'readOnlyReferenceNumberFormGroup'">
				<label class="col-md-4 col-form-label">Reference/Check #</label>
				<div class="col-md-8">
					<p class="form-control-static">{{ paymentGroup.referenceNumber }}</p>
				</div>
			</div>
			<div class="row mb-3 margin-bottom-0" [attr.data-test-id]="'readOnlyPaymentDateFormGroup'">
				<label class="col-md-4 col-form-label">Payment Date</label>
				<div class="col-md-8">
					<p class="form-control-static">{{ paymentGroup.paymentDate | date: dateFormat }}</p>
				</div>
			</div>
			<div class="row mb-3 margin-bottom-0" [attr.data-test-id]="'readOnlyLocationFormGroup'">
				<label class="col-md-4 col-form-label">Location</label>
				<div class="col-md-8">
					<p class="form-control-static">{{ locationName }}</p>
				</div>
			</div>
		</div>
		<div class="col-lg-6 col-xl-4">
			<div class="row mb-3 margin-bottom-0" [attr.data-test-id]="'readOnlyCommentsFormGroup'">
				<label class="col-md-4 col-form-label">Comments</label>
				<div class="col-md-8">
					<div class="form-control-static">{{ paymentGroup.comment }}</div>
				</div>
			</div>
		</div>
	</div>
	<div class="h385">
		<ag-grid-angular
			class="ag-theme-alpine hFull"
			pmsAgAutoFitColumns
			#invoicePaymentsGrid
			[gridOptions]="invoicePaymentsGridOptions"
			[rowData]="invoicePayments"
			(gridReady)="updateAggregateRow()"
			[pagination]="false"
			[attr.data-test-id]="'readOnlyinvoicePaymentFormGroup'">
		</ag-grid-angular>
	</div>
</form>
